module.exports = __webpack_public_path__ + "static/media/is_conference_hall.ada23f9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_conference_hall.svg
// module id = 1524
// module chunks = 0